/**
 * Cashflow Analysis - UI Types & Constants
 */

export type CashflowViewMode = 'total' | 'bySupplier' | 'byPO';
export type StatusFilter = 'all' | 'placed' | 'forecasted';
export type PaymentStatusFilter = 'all' | 'paid' | 'unpaid';
export type ChartStackingMode = 'bySupplier' | 'byStatus';

export const STATUS_FILTER_OPTIONS: Array<{ value: StatusFilter; label: string }> = [
  { value: 'all', label: 'All' },
  { value: 'placed', label: 'Placed' },
  { value: 'forecasted', label: 'Forecasted' },
];

export const PAYMENT_STATUS_OPTIONS: Array<{ value: PaymentStatusFilter; label: string }> = [
  { value: 'all', label: 'All' },
  { value: 'paid', label: 'Paid' },
  { value: 'unpaid', label: 'Unpaid' },
];

export const VIEW_MODE_OPTIONS: Array<{ value: CashflowViewMode; label: string }> = [
  { value: 'byPO', label: 'By PO' },
  { value: 'bySupplier', label: 'By Supplier' },
  { value: 'total', label: 'Total' },
];

export const CHART_STACKING_OPTIONS: Array<{ value: ChartStackingMode; label: string }> = [
  { value: 'bySupplier', label: 'By Supplier' },
  { value: 'byStatus', label: 'By Status' },
];

export const SUPPLIER_COLORS: string[] = [
  '#93C5FD', // Soft Blue
  '#6EE7B7', // Soft Emerald
  '#C4B5FD', // Soft Purple
  '#FDBA74', // Soft Orange
  '#67E8F9', // Soft Teal
  '#F9A8D4', // Soft Pink
  '#A5B4FC', // Soft Indigo
  '#BEF264', // Soft Lime
  '#D8B4FE', // Soft Violet
  '#FCA5A5', // Soft Red
];

export const STATUS_COLORS: Record<string, string> = {
  placed: '#60A5FA',
  forecasted: '#CBD5E1',
};

export const BRAND_OPTIONS = [
  'Noonlash',
  'Dosaze',
];
